/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import cx from 'classnames';
import './Header.scss';

import LogoImage from 'images/svg/logo.svg';

import MobileMenuButton from './MobileMenuButton';
import MobileMenu from './MobileMenu';
import ButtonLink from './ButtonLink';
import Button from './Button';

const Header = ({ toggleMobileMenu, isMenuOpen, navigation }) => {
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY >= 30) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
    }
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <header className={cx({ header: true, 'header--scrolled': scrolled })}>
        <div className="header__container">
          <Link to="/">
            <LogoImage className="header__logo" />
          </Link>
          <div className="header__nav">
            {navigation.map(({ link }) => (
              <ButtonLink key={link.to} link={link} isNavLink size="sm" isHeader />
            ))}
          </div>
          <Button className="header__request-quote-btn" variant="secondary" to="/request-quote">
            REQUEST A QUOTE
          </Button>
        </div>
      </header>

      {/* Mobile */}
      <MobileMenuButton toggleMobileMenu={toggleMobileMenu} isMenuOpen={isMenuOpen} />
      <MobileMenu
        isMenuOpen={isMenuOpen}
        navigation={navigation}
        toggleMobileMenu={toggleMobileMenu}
      />
    </>
  );
};
export default Header;
